import tw, { styled } from 'twin.macro'
import type { TCheckboxLabelStyles, TCheckboxStyles } from './Checkbox.interface'

export const StyledLabel = styled.label(({ isDisabled = false }: TCheckboxLabelStyles) => [
  tw`font-body flex flex-row items-start hover:cursor-pointer`,
  isDisabled,
])

export const StyledCheckbox = styled.div(
  ({ isDisabled = false, isFocused = false, isError = false }: TCheckboxStyles) => [
    tw`w-5 h-5 mt-0.5 mr-2.5 border-[#FDD6B7] bg-white rounded-[5px] border-2 shrink-0 hover:cursor-pointer flex items-center justify-center`,
    isDisabled && tw`bg-[#F7643B]`,
    isFocused && tw`outline-black [outline-offset: 2px]`,
    isError && tw`border-red-500`,
  ],
)
